import { useContext } from "react"
import AuthContext from "../context/AuthProvider";


const useUserPermissions = () => {

    const { permissions } = useContext(AuthContext);

    const perms = permissions?.map((el) => el.name)

    // Permission checking function
    const hasPermission = (permission) => {
        return perms?.some((el) => el === permission || el === "manage-all")
    }

    /* Permissions List */
    const apiPermissions = {
        // Role permissions
        changeRoleStatus: hasPermission("change role status"),
        getAllRoles: hasPermission("get all roles"),
        getRole: hasPermission("get role"),
        createRole: hasPermission("create role"),
        deleteRole: hasPermission("delete role"),
        updateRole: hasPermission("update role"),

        // Identity provider permissions
        deleteIdentityProvider: hasPermission("delete identity provider"),
        getIdentityProvider: hasPermission("get identity provider"),
        getAllIdentityProviders: hasPermission("get all identity providers"),
        createIdentityProvider: hasPermission("create identity provider"),
        updateIdentityProvider: hasPermission("update identity provider"),

        // User permissions
        updateUserStatus: hasPermission("update user status"),
        deleteUser: hasPermission("delete user"),
        createUser: hasPermission("create user"),
        getUser: hasPermission("get user"),
        getAllUsers: hasPermission("get all users"),
        resetUserPassword: hasPermission("reset user password"),
        revokeUsersRole: hasPermission("revoke user's role"),
        updateUserRole: hasPermission("update user role"),

        // Scope permissions
        createScope: hasPermission("create scope"),
        updateScope: hasPermission("update scope"),
        getScope: hasPermission("get scope"),
        getAllScopes: hasPermission("get all scopes"),
        deleteScope: hasPermission("delete scope"),

        // Resource server permissions
        createResourceServer: hasPermission("create resource server"),
        getAllResourceServers: hasPermission("get all resource servers"),

        // Permission permissions
        getAllPermissions: hasPermission("get all permissions"),

        // Client permissions
        getAllClients: hasPermission("get all clients"),
        getClient: hasPermission("get client"),
        deleteClient: hasPermission("delete client"),
        updateClient: hasPermission("update client"),
        updateClientStatus: hasPermission("update client status"),
        createClient: hasPermission("create client"),

        // Page access getters
        get rolesPage() {
            return (
                this.createRole ||
                this.deleteRole ||
                this.getAllRoles ||
                this.getRole ||
                this.changeRoleStatus ||
                this.updateRole ||
                this.updateUserRole ||
                this.revokeUsersRole
            )
        },

        get usersPage() {
            return (
                this.createUser ||
                this.deleteUser ||
                this.getAllUsers ||
                this.getUser ||
                this.updateUserStatus ||
                this.resetUserPassword
            )
        },

        get identityProvidersPage() {
            return (
                this.createIdentityProvider ||
                this.deleteIdentityProvider ||
                this.getAllIdentityProviders ||
                this.getIdentityProvider ||
                this.updateIdentityProvider
            )
        },

        get clientsPage() {
            return (
                this.createClient ||
                this.deleteClient ||
                this.getAllClients ||
                this.getClient ||
                this.updateClient ||
                this.updateClientStatus
            )
        },

        get scopesPage() {
            return (
                this.createScope ||
                this.deleteScope ||
                this.getAllScopes ||
                this.getScope ||
                this.updateScope
            )
        },

        get resourceServersPage() {
            return (
                this.createResourceServer ||
                this.getAllResourceServers
            )
        },

        get permissionsPage() {
            return this.getAllPermissions
        },
    }

    return apiPermissions
}

export default useUserPermissions
